$(document).ready(function () {

    const initDelay = 2000;
    const disableEntryOn = [
        '404',
        'companyinfo',
        'how_it_works',
        'blog',
        'newsroom',
        'privacy',
        'cookies-policy',
        'terms_of_website_use',
        'subscribe',
        'da20',
        'events',
        'krypto-etp-startseite',
        'krypto-etp-startsida',
        'etp-su-criptovalute',
        '5-years-btce-on-xetra',
        'uk-crypto-etps',
        'btcg-bitcoin-and-gold',
    ];

    function initEntry() {
        const disableEntry = disableEntryOn.some(check => location.href.includes(check)) || $('[data-404]').length > 0;

        drawSavedForm(document.getElementById('sib-form'))

        if (!disableEntry && !$.cookie('filterAccepted')) {
            setTimeout(() => {
                $('#entryModal').toggleClass('show');
                showGroups(['uk_private', 'footer','investor','settings']);
            }, initDelay);
        }

        if ($.cookie('filterAccepted') && !$.cookie('cookiehide')) {
            showCookiesSettings();
        }
    }

    function showGroups(groupsArray) {
        $('#entryModal [data-group]').each(function () {
            $(this).addClass('d-none');

            let groups = $(this).attr('data-group').split(',');

            for (group of groups) {
                if (groupsArray.includes(group)) $(this).removeClass('d-none');
            }
        })
    }
    
    $('#leaveSiteBtn').click(() => location.href = 'https://www.google.com/');

    $('[data-open-country]').click(() => {
        showGroups(['uk_private', 'footer','investor','settings']);
        $('#entryModal').toggleClass('show');
    });

    $('[data-open-investor]').click(() => {
        showGroups(['uk_private', 'footer','investor','settings']);
        $('#entryModal').toggleClass('show');
    });


    $('#acceptSettings, #acceptOther, #keepEUBtn').click(() => {
        $.cookie('filterAccepted', true, { path: '/', secure: true });
        window.location.reload()
    })

    $('#cookieD').click(function () {
        if ($('#optCookies').attr('data-switch') === 'on') $('#optCookies').click();
    });
    $('#cookieB').click(() => {
        $.cookie("cookiehide", 1, { path: '/', secure: true });
        $('.aside-cookiewrap').removeClass('show');
    });

    initEntry();

    function showCookiesSettings() {
        $('.aside-cookiewrap').addClass('show');
    }

    $(document).on('click', '[data-showcookiessettings]', function(){
        console.log($(this));
        showCookiesSettings();
    });
})